import React from 'react';
import Tooltip from '../Tooltip';
import { FaIcon } from '../Icons';

function MessageCountHeader({title}){
  return <Tooltip title={title} trigger='click'>
      <FaIcon type='comments' />
  </Tooltip>
}

export default MessageCountHeader;
